import React, { ReactNode } from 'react';
import { ChipFilterItem } from './chip-filter-item';
import './chip-filter.scss';
import { ChipFilterSection } from '../../types';
import { SearchComponent } from '../search/search';
import { WrapperdFilterButton } from '../filter';
import { FilterRoute } from '@zonofi/zono-money-store';

interface ChipFiltersProps {
  sections: (ChipFilterSection | JSX.Element)[];
  startElement?: ReactNode;
  chipFilterStyles?: React.CSSProperties;
  showSearch?: boolean;
  search?: SearchComponent;
  filterRoute?: FilterRoute;
  setShowFilter?: (val: boolean) => void;
}

export const ChipFilters: React.FC<ChipFiltersProps> = ({
  sections,
  startElement,
  chipFilterStyles = {} as React.CSSProperties,
  search,
  showSearch,
  filterRoute,
  setShowFilter,
}) => {
  if (sections?.length === 0) return null;

  const searchInput = search?.searchInput;
  const searchResult = search?.searchResult;

  return (
    <div className="chip-filters" style={{ ...chipFilterStyles }}>
      {/* LEFT SEARCH */}
      {searchInput && searchInput.component}

      {/* SCROLLABLE CHIPS */}
      <div className="chip-scroll">
        {startElement}

        {((searchInput && !searchInput?.state?.showSearch) || !searchInput) &&
          sections.map((section, index) => {
            if (React.isValidElement(section)) {
              return <React.Fragment key={index}>{section}</React.Fragment>;
            }

            const { items, onItemPress } = section as ChipFilterSection;

            return (
              <React.Fragment key={index}>
                {items.map((item) => (
                  <ChipFilterItem
                    key={item.id}
                    {...item}
                    onPress={() => onItemPress(item)}
                  />
                ))}
                {index !== sections.length - 1 && (
                  <div className="section-divider" />
                )}
              </React.Fragment>
            );
          })}
      </div>

      {/* RIGHT FILTER */}
      {filterRoute && !showSearch && (
        <div className="filter-view">
          <WrapperdFilterButton
            route={filterRoute}
            color="#000000"
            onClick={() => setShowFilter?.(true)}
          />
        </div>
      )}

      {searchResult &&
        searchResult?.state?.showSearchWindow &&
        searchResult?.component}
    </div>
  );
};
